<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="analyze-item-list" v-if="['SFM', 'SSM', 'FSM'].includes(artefact.type)">
    <!-- <pre>{{filter}}</pre> -->
    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <div class="vx-row" v-if="showContainer.category">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'FSM' ? 'Categories by Rate of Sale' :
            (artefact.type === 'SFM' ? 'Top Selling Categories by Rate of Sale' : 'Slow Moving Categories by Rate of Sale')">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.category.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.category.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('category')" />

                <feather-icon
                  icon="FilterIcon"
                  class="cursor-pointer"
                  :svgClasses="[{'text-success stroke-current': filter.apply}, {'text-danger stroke-current': !filter.apply}, 'w-5', 'h-5 mr-4']"
                  @click.stop="switchFilter" />

                <feather-icon
                  icon="RefreshCcwIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="resetFilter"
                  v-if="filter.apply"
                  />
              </div>
            </template>
            <vs-table pagination max-items="10" search :data="units.category.data">

              <template slot="thead">
                <vs-th>Sl. No.</vs-th>
                <vs-th sort-key="long_description" v-if="showCol('category', 'long_description')">Sku Desc</vs-th>
                <vs-th sort-key="brand" v-if="showCol('category', 'brand')">Brand</vs-th>
                <vs-th sort-key="product_category" v-if="showCol('category', 'product_category')">Category</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('category', 'quantity')">Units/Day</vs-th>
                <vs-th sort-key="type" v-if="showCol('category', 'type')">Sale Type &amp; Level</vs-th>
                <vs-th>Brand / Sku Details</vs-th>
              </template>

              <template slot-scope="{data}">
                <!-- <vs-tr :state="data[indextr].type == 'fast' ? 'success': data[indextr].type == 'slow' ? 'danger': null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"> -->
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].long_description" v-if="showCol('category', 'long_description')">
                    {{ data[indextr].long_description }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('category', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_category" v-if="showCol('category', 'product_category')">
                    <vs-breadcrumb>
                      <!-- <li><vs-avatar size="small" :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /></li> -->
                      <li @click="applyFilter('category', 'product_category', false, 1, data[indextr])" class="text-dark" v-if="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)">{{ data[indextr].product_category }}</li>
                      <li @click="applyFilter('category', 'product_category', false, -1, data[indextr])" class="font-bold text-dark" v-if="(filter.apply && data[indextr].level< 4 && (data[indextr].level !== filter['category'].level))">{{ data[indextr].product_category }}</li>
                      <li @click="applyFilter('category', 'product_category', false, -1, data[indextr])" class="text-grey" v-if="(filter.apply && data[indextr].level> 3 && (data[indextr].level === filter['category'].level))">{{ data[indextr].product_category }}</li>
                      <li class="text-gray" v-if="!filter.apply">{{ data[indextr].product_category }}</li>
                      <!-- <feather-icon
                        icon="FilterIcon"
                        svgClasses="ml-3 w-4 h-4 text-grey"
                        @click="openContainer('sku', 'product_category', true, 0, data[indextr])"
                      ></feather-icon> -->
                    </vs-breadcrumb>

                    <!-- <feather-icon
                      icon="CornerUpLeftIcon"
                      svgClasses="ml-3 w-4 h-4 text-grey"
                      @click="applyFilter('category', 'product_category', false, -1, data[indextr])"
                      v-show="filter.apply && data[indextr].level > 1"
                    ></feather-icon> -->
                    <!-- <feather-icon
                      icon="FilterIcon"
                      svgClasses="ml-3 w-4 h-4 text-grey"
                      @click="applyFilter('category', 'product_category', false, 1, data[indextr])"
                      v-show="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)"
                    ></feather-icon> -->
                  </vs-td>

                  <vs-td :data="data[indextr].quantity" v-if="showCol('category', 'quantity')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0.00') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.category.upd))*100" :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')"></vs-progress>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('category', 'type')">
                    <!-- <vs-avatar :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /> -->
                    <vs-chip :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')">{{data[indextr].type}}</vs-chip>
                    <vs-chip class="ml-2">level {{data[indextr].level}}</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('category', 'type')">
                    <feather-icon
                      icon="TagIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('brand', 'product_category', true, 1, data[indextr])"
                    ></feather-icon>
                    <feather-icon
                      icon="LayersIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('sku', 'product_category', true, 1, data[indextr])"
                    ></feather-icon>
                    <!-- <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">Brands</vs-button>
                    <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">Skus</vs-button> -->
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.brand">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'FSM' ? 'Brands of Category by Rate of Sale' :
            (artefact.type === 'SFM' ? 'Top Selling Brands by Categories & Rate of Sale' : 'Slow Moving Brands by Categories & Rate of Sale')">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.sku.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.sku.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('brand')" />

                <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  v-if="type === 'category'"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideContainer('category')"
                  />

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table pagination max-items="10" search :data="units.brand.data">

              <template slot="thead">
                <vs-th>Sl. No.</vs-th>
                <vs-th sort-key="long_description" v-if="showCol('brand', 'long_description')">Sku Desc</vs-th>
                <vs-th sort-key="brand" v-if="showCol('brand', 'brand')">Brand</vs-th>
                <vs-th sort-key="cat_lookup" v-if="showCol('brand', 'cat_lookup')">Category</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('brand', 'quantity')">Units/Day</vs-th>
                <vs-th sort-key="type" v-if="showCol('brand', 'type')">Sale Type &amp; Level</vs-th>
                <vs-th>Details</vs-th>
              </template>

              <template slot-scope="{data}">
                <!-- <vs-tr :state="data[indextr].type == 'fast' ? 'success': data[indextr].type == 'slow' ? 'danger': null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"> -->
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].long_description" v-if="showCol('brand', 'long_description')">
                    {{ data[indextr].long_description }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('brand', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td :data="data[indextr].cat_lookup" v-if="showCol('brand', 'cat_lookup')">
                      {{ data[indextr].cat_lookup }}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity" v-if="showCol('brand', 'quantity')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0.00') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.brand.upd))*100" :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')"></vs-progress>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('brand', 'type')">
                    <!-- <vs-avatar :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /> -->
                    <vs-chip :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')">{{data[indextr].type}}</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('brand', 'type')">
                    <!-- <feather-icon
                      icon="LayersIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('sku', 'product_category', true, 1, data[indextr])"
                      v-show="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)"
                    ></feather-icon> -->
                    <!-- <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">Brands</vs-button> -->
                    <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'brand,product_category', true, 1, data[indextr], 'eq,sw')">Skus</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.sku">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'FSM' ? 'Skus by Rate of Sale' :
            (artefact.type === 'SFM' ? 'Top Selling Skus by Rate of Sale' : 'Slow Moving Skus by Rate of Sale')">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.sku.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.sku.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('sku')" />

                <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  v-if="type === 'category'"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideContainer('brand')"
                  />

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table pagination max-items="10" search :data="units.sku.data">

              <template slot="thead">
                <vs-th></vs-th>
                <vs-th sort-key="desc" v-if="showCol('sku', 'desc')">Sku Desc</vs-th>
                <vs-th sort-key="product_category" v-if="showCol('sku', 'product_category')">Category</vs-th>
                <vs-th sort-key="brand" v-if="showCol('sku', 'brand')">Brand</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('sku', 'quantity')">Units/Day</vs-th>
                <vs-th sort-key="ctc">CTC ( {{ '' | currencySymbol }} )</vs-th>
                <vs-th sort-key="inventory">Inventory</vs-th>
                <vs-th sort-key="type">Type</vs-th>
                <vs-th sort-key="is_alert" v-if="showCol('sku', 'is_alert')">Alert</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].desc" v-if="showCol('sku', 'desc')">
                    {{ data[indextr].desc }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].cat_lookup" v-if="showCol('sku', 'product_category')">
                    {{ data[indextr].cat_lookup }}
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('sku', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity" v-if="showCol('sku', 'quantity')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0.00') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.category.upd))*100" :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')"></vs-progress>
                  </vs-td>

                  <vs-td :data="data[indextr].ctc">
                    {{ '~' | numFormat }}
                  </vs-td>

                  <vs-td :data="data[indextr].inventory">
                    {{ '~' | numFormat }}
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('sku', 'type')">
                    <!-- <vs-avatar :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="1" :text="data[indextr].type" /> -->
                    <vs-chip :color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')">{{data[indextr].type}}</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].is_alert" v-if="showCol('sku', 'is_alert')">
                    <feather-icon icon="AlertTriangleIcon" svgClasses="w-6 h-6 text-danger" v-if="data[indextr].is_alert === 1"></feather-icon>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from 'vue-select';

import {fetchArtefactUnit} from "../shared/services";


export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      showStatsPanel: true,
      popupActive: false,
      colorx:"#e1e1e1",

      showContainer: {
        category: true,
        brand: false,
        sku: false
      },
      unitSelected: [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      units: {
        category: {
          upd: 1.0,
          headers: [],
          data: []
        },
        brand: {
          upd: 1.0,
          headers: [],
          data: []
        },
        sku: {
          upd: 1.0,
          headers: [],
          data: []
        },
      },
      filter: {
        apply: true,
        category: {
          active: true,
          level: 1,
          flat: false,
          rule: []
        },
        brand: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        },
        sku: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        }
      },
      stores: {
          "ccb23788-2d92-11e1-8194-0015c5e16c09": "Cagueuyes",
          "ccb2363e-2d92-11e1-8194-0015c5e16c09": "Paradise ",
          "cc91c7e6-2d92-11e1-8194-0015c5e16c09": "Palero"
      },

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      header: {
        category: {
          title: ["Sl. No.", "Category", "Level", "Units / Day", "Performance"],
          value: ["row", "product_category", "level", "quantity", "type"]
        },
        brand: {
          title: ["Sl. No.", "Brand", "Category", "Units / Day", "Performance"],
          value: ["row", "brand", "cat_lookup", "quantity", "type"]
        },
        sku: {
          title: ["Sl. No.", "Sku Id", "Desc", "Category", "Brand", "Units / Day","Performance"],
          value: ["row", "sku_id", "desc", "product_category", "brand", "quantity", "type"]
        }
      },
      activePrompt: false,
      exportType: null

    };
  },
  watch: {},
  computed: {
    // ...mapGetters({order: "analyze/artefactUnit"})
  },
  methods: {
    init(){
      this.fetchUnits('category');
      this.fetchUnits('brand');
      this.fetchUnits('sku');

      this.switchContainer(this.type);
    },
    fetchUnits(type) {
      this.units[type].data = this.formatItemsData(type);
      if(this.units[type] && this.units[type].data.length > 0) {
        // this.units[type].upd = this.units[type].data.reduce(function(prev, cur) {
        //   if(cur.level === 1) {
        //     return prev + cur.quantity;
        //   } else {
        //     return prev;
        //   }
        // }, 0);
        this.units[type].upd = this.units[type].data[0].quantity;
        this.units[type].headers = Object.keys(this.units[type].data[0]);
      }
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(this.artefact.type, this.artefact.res.trend[type], type);

      if(this.artefact.type === 'SFM' || this.artefact.type === 'FSM') {
        units.reverse();
      }
      if(units.length > 0) {
        for(var i = 0; i < units.length; i++) {
          units[i].row = i+1;
        }
      }

      return units;
    },
    filterAndSortData(rtype, data, dtype) {

      let filteredData = data.filter(
        t => (
          ((rtype === 'SFM' && t.type === 'fast') || (rtype === 'SSM' && t.type === 'slow') || rtype === 'FSM') &&
          (this.filter.apply && !this.filter[dtype].flat && this.filter[dtype].active && this.filter[dtype] && this.filter[dtype].level ? (t.level <= (this.filter[dtype].level)) : true) &&
          ((this.filter.apply && this.filter[dtype] && this.filter[dtype].active) ? this.handleFilterRule(this.filter[dtype].rule, t) : true)
        )
      );

      return filteredData.sort(function(t1, t2) {
        var upd1 = t1.quantity;
        var upd2 = t2.quantity;

        var cat1 = t1.product_category;
        var cat2 = t2.product_category;

        if (upd1 < upd2) {
          return -1;
        } else if (upd1 > upd2) {
          return 1;
        } else if (cat1 < cat2) {
          return 1;
        } else if (cat1 > cat2) {
          return -1;
        }

        // tags must be equal
        return 0;
      });

    },
    handleFilterRule(rules, t) {
      let flag = false;
      if(rules && rules.length > 0) {
        for(var pos = 0; pos < rules.length; pos++) {
          let rule = rules[pos];
          if(t[rule.key]) {
            if(rule.check === 'sw'){
              flag = t[rule.key].startsWith(rule.lookup);
            } else if(rule.check === 'eq'){
              flag = t[rule.key] === rule.lookup;
            } else if(rule.check === 'ne'){
              flag = t[rule.key] !== rule.lookup;
            } else if(rule.check === 'ct'){
              flag = t[rule.key].contains(rule.lookup);
            }
            if(!flag) break;
          } else {
            flag = true;
          }
        }
      } else {
        flag = true;
      }

      return flag;
    },

    showCol(type, key) {
      return this.units[type].headers.includes(key);
    },
    switchContainer(type) {
      Object.entries(this.showContainer).forEach(([key, value]) => {
        if(type === key) {
          this.showContainer[key] = true;
        } else {
          this.showContainer[key] = false;
        }
      });
    },

    applyFilter(dtype, keys, flat, rollTo, data, ruleCheckType) {
      if(this.filter.apply) {
        this.filter.data = data;
        this.filter.rollTo = rollTo;
        this.filter.flat = flat;
        this.filter[dtype].active = true;

        this.filter[dtype].level = this.filter[dtype].level + (1 * rollTo);
        this.filter[dtype].flat = flat;
        
        this.filter[dtype].rule = [];
        let  keyArr = keys.split(",");
        let ruleCheck = ruleCheckType ? ruleCheckType.split(",")  : [];

        for(let pos = 0; pos < keyArr.length; pos++){ 
          let rule = {
            key: '',
            lookup: '',
            check: ''
          };

          let key = keyArr[pos];
          if(!flat && this.filter[dtype].level > 1) {
            var cat = data[key].split(" / ", this.filter[dtype].level-1);
            cat = cat.filter(c => c !== 'ZCat')
            rule.key = key;
            rule.lookup = cat ? cat.join(" / ") : data[key];
            rule.check = ruleCheck && ruleCheck.length > 0 ? ruleCheck[pos] : "sw";

            this.filter[dtype].rule.push(rule);

          } else if(flat) {
            var cat = data[key].split(" / ", this.filter[dtype].level+1);
            cat = cat.filter(c => c !== 'ZCat')
            rule.key = key;
            rule.lookup = cat ? cat.join(" / ") : data[key];
            rule.check = ruleCheck && ruleCheck.length > 0 ? ruleCheck[pos] : "sw";

            this.filter[dtype].rule.push(rule);
          }
        }
      }

      this.fetchUnits(dtype);
    },
    switchFilter() {
      this.filter.apply = !this.filter.apply;
      if(!this.filter.apply) {
        this.resetFilter();
      }
      this.init();
    },

    resetFilter() {
      this.filter = {
        apply: this.filter.apply,
        category: {
          active: true,
          level: 1,
          flat: false,
          rule: []
        },
        brand: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        },
        sku: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        }
      };

      this.init();
    },

    exportData(type) {
      this.exportType = type;
      if(this.artefact.type === "FSM") {
        this.fileName = "Performance_by_ROS_"+type
      } else {
        this.fileName = (this.artefact.type === "SFM") ? "FastMovers_"+type : "SlowMovers_"+type;
      }
      this.activePrompt=true;
    },

    openContainer(dtype, key, flat, rollTo, data, ruleCheckType) {
      this.applyFilter(dtype, key, flat, rollTo, data, ruleCheckType);
      this.switchContainer(dtype);
    },
    hideContainer(dtype) {
      this.moverContainerTitle = "";
      this.switchContainer(dtype);
    },

    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.units[this.exportType].data;
        const data = this.formatJson(this.header[this.exportType].value, list)
        excel.export_json_to_excel({
          header: this.header[this.exportType].title,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    }

  },
  mounted() {
    this.init();
  },
  components: {
    vSelect
  }
};
</script>

<style lang="scss">
#analyze-item-list {
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
